import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Toggle.module.scss';
export const Toggle = ({ checked = false, onChange }) => {
    const handleChange = (e) => {
        onChange?.(e.target.checked);
    };
    const toggleClasses = [styles.toggle, checked ? styles['toggle--checked'] : '']
        .filter(Boolean)
        .join(' ');
    return (_jsxs("label", { className: styles['toggle-wrapper'], children: [_jsx("input", { type: "checkbox", className: styles.toggle__input, checked: checked, onChange: handleChange }), _jsx("span", { className: toggleClasses, children: _jsx("span", { className: styles.toggle__slider }) })] }));
};
